<template>
    <div class="empty_page">
        <img src="../../assets/image/ttWork/empty-icon.png" alt="">
        <div>{{text || '暂无数据'}}</div>
    </div>
</template>

<script>
    export default {
        name: "EmptyPage",
        props: ['text']
    }
</script>

<style lang="scss" scoped>
    .empty_page{
        text-align: center;
        font-size: 25px;
        /*color: #A5A5A5;*/
        color: rgb(104, 179, 242);
        margin: 0 auto;
        img{
            zoom: .5;
        }
        div{
            margin-top: 10px;
        }
    }
</style>
